<template>
    <el-dialog
            title="选择员工"
            :visible="true"
            width="70%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="员工编号:">
                <el-input v-model="form.dealer_sn" clearable></el-input>
            </el-form-item>
            <el-form-item label="姓名:">
                <el-input v-model="form.dealer_name" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号:">
                <el-input v-model="form.dealer_name" clearable></el-input>
            </el-form-item>
            <el-form-item label="类型:">
                <el-select v-model="value">
                    <el-option
                            v-for="item in typeArr"
                            :key="item.id"
                            :label="item.type_name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="管理范围:">
                <el-select v-model="regionOneVal" placeholder="请选择" @change="selectLevelOne">
                        <el-option
                                v-for="item in regionOne"
                                :key="item.region_id"
                                :label="item.region_name"
                                :value="item.region_id">
                        </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-select placeholder="请选择" v-model="regionTwoVal" @change="selectLevelTwo">
                        <el-option
                                v-for="item in regionTwo"
                                :key="item.region_id"
                                :label="item.region_name"
                                :value="item.region_id">
                        </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-select  placeholder="请选择" v-model="regionThreeVal" @change="selectLevelThree">
                        <el-option
                                v-for="item in regionThree"
                                :key="item.region_id"
                                :label="item.region_name"
                                :value="item.region_id">
                        </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-select placeholder="请选择" v-model="regionFourVal" >
                        <el-option
                                v-for="item in regionFour"
                                :key="item.region_id"
                                :label="item.region_name"
                                :value="item.region_id">
                        </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getStaff()">搜索</el-button>
            </el-form-item>
        </el-form>
        <span>提示：员工资料请在【客户】-【员工管理】中添加、管理。</span>
        <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                height="300"
                border
                stripe
                style="margin: 20px 0"
                @selection-change="handleSelectionChange">
            <el-table-column
                    type="selection"
                    :selectable="selectable"
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="staff_sn"
                    label="员工编号"
                    width="120"
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="staff_name"
                    label="姓名"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="mobile"
                    label="手机号"
                    width="180"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="region"
                    label="管理范围"
                    width="180"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                   <span v-for="(item,index) in scope.row.region">{{item}}&nbsp;&nbsp;</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="type_name"
                    label="类型"
                    width="180"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    width="180"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button v-if="scope.row.flag== 1" type="text" disabled size="mini">已选择</el-button>
                    <el-button v-else  type="text" size="small" @click="choose(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-button type="primary" style="margin-bottom: 10px" @click="chooseMulti()">多选</el-button>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
    </el-dialog>
</template>

<script>
    export default {
        name: "add-worker",
        data() {
            return {
                postUrl:'',
                form: {
                    staff_sn:'',
                    staff_name:'',
                    keywords:''
                },
                tableData: [],
                multipleSelection: [],
                typeArr:[],
                //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                regionOne:[],//管辖范围一级
                regionTwo:[],//管辖范围二级
                regionThree:[],//管辖范围三级
                regionFour:[],//管辖范围四级
                regionOneVal:'',
                regionTwoVal:'',
                regionThreeVal:'',
                regionFourVal:'',
                value:'',
            }
        },
        props:{
            pushData:{
                type:Array,
                default:[]
            },
            type:{
                type:Number,
                default:0
            },
            notice_id:{
                type:String,
                default:''
            },
            source:{
                type:String,
                default:''
            }
        },
        methods:
            {
                //获取员工类型
                getWorkerType(){
                    this.$get(this.global + '/staffs.types', {
                    }).then(res => {
                        this.typeArr = res.data;
                    }).catch(error =>{

                    });

                },
                //获取管辖范围一级
                getRegionOne(){
                    this.$get(this.global + '/staffs.regions', {
                    }).then(res => {
                       this.regionOne = res.data;
                    }).catch(error =>{

                    });
                },
                //根据一级的获取二级
                selectLevelOne(val){
                    this.regionTwoVal = '';
                    this.regionThreeVal = '';
                    this.regionFourVal = '';
                    this.$get(this.global + '/staffs.regions', {
                        parent_id:val
                    }).then(res => {
                        this.regionTwo = res.data;
                    }).catch(error =>{

                    });
                },
                //根据二级获取三级
                selectLevelTwo(val){
                    this.regionThreeVal = '';
                    this.regionFourVal = '';
                    this.$get(this.global + '/staffs.regions', {
                        parent_id:val
                    }).then(res => {
                        this.regionThree = res.data;
                    }).catch(error =>{

                    });
                },
                //根据三级获取四级
                selectLevelThree(val){
                    this.regionFourVal = '';
                    this.$get(this.global + '/staffs.regions', {
                        parent_id:val
                    }).then(res => {
                        console.log(res);
                        this.regionFour = res.data;
                    }).catch(error =>{

                    });
                },
                getStaff(){
                    this.loading = true;
                    let region_id = '';
                    if(this.regionFourVal){
                        region_id = this.regionFourVal
                    }else if(this.regionThreeVal && !this.regionFourVal){
                        region_id = this.regionThreeVal
                    }else if(this.regionTwoVal && !this.regionThreeVal){
                        region_id = this.regionTwoVal
                    }else if(this.regionOneVal && !this.regionTwoVal){
                        region_id = this.regionOneVal
                    }
                    console.log(region_id);
                    this.$get(this.global + '/staffs', {
                        per_page:this.pageSize,
                        page:this.pageNo,
                        staff_sn:this.form.staff_sn,
                        staff_name:this.form.staff_name,
                        isself:'',
                        keywords:this.form.keywords,
                        region_id:region_id
                    }).then(res => {
                        this.loading = false;
                        if(this.pushData.length == 0 ){
                            this.tableData = res.data;
                        }else{
                            this.arrayRiff(res.data,this.pushData);
                            this.tableData = res.data;
                        }
                        this.totalSize = res.meta.total;
                    }).catch(error =>{
                        this.loading = false;
                    });

                },
                /*判别是否可以选*/
                selectable(row,index){
                    if(row.flag && row.flag == 1){
                        return false;
                    }else{
                        return true;
                    }
                },
                /*单选*/
                choose(row){
                    if(this.type == 2){
                        let snArr = [];
                        snArr.push(row.staff_sn);
                        let url = this.postUrl+ this.notice_id + '/designee'
                        this.$patch(this.global +url, {
                            notice: this.notice_id,
                            lang:'',
                            _method:'PATCH',
                            designee_type: 3,
                            designee_sns:snArr
                        }).then(res => {
                            this.$emit('onSearch');
                            this.$emit('refresh');
                            this.$emit('handleClose');
                        }).catch(error =>{

                        });
                        return;
                    }
                    this.$emit('submit',row);
                    this.$emit('handleClose');
                },
                /*多选*/
                chooseMulti(){
                    if(this.multipleSelection.length == 0){
                        this.$message.error('请勾选数据...');
                        return;
                    }
                    if(this.type == 2){
                        let snArr = [];
                        for(var i = 0; i < this.multipleSelection.length;i++){
                            snArr.push(this.multipleSelection[i].staff_sn);
                        }
                        let url = this.postUrl+ this.notice_id + '/designee'
                        this.$patch(this.global +url, {
                            notice: this.notice_id,
                            lang:'',
                            _method:'PATCH',
                            designee_type: 3,
                            designee_sns:snArr
                        }).then(res => {
                            this.$emit('onSearch');
                            this.$emit('refresh');
                            this.$emit('handleClose');
                        }).catch(error =>{

                        });
                        return;
                    }
                    this.$emit('submit',this.multipleSelection);
                    this.$emit('handleClose');
                },
                //数组查询重复
                arrayRiff(a, b) {
                    for (var i = 0; i < b.length; i++) {
                        for (var j = 0; j < a.length; j++) {
                            if (a[j].staff_sn == b[i].staff_sn) {
                                a[j].flag = 1;
                            }
                        }
                    }
                    return a;
                },
                /*分页*/
                handleSizeChange(val) {
                    this.pageSize = val;
                    this.pageNo = 1;
                    this.getStaff();
                },
                handleCurrentChange(val) {
                    this.pageNo = val;
                    this.getStaff();
                },
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                },
                handleClose(){
                    this.$emit('handleClose');
                }
            },
        created() {
            if(this.source == '公告'){
                this.postUrl = '/notices/';

            }else if(this.source == '文件'){
                this.postUrl = '/documents/'
            }
            this.getRegionOne();
            this.getWorkerType();
            this.getStaff();
        },
    }
</script>

<style lang="scss" scoped>

</style>